import { motion } from "framer-motion";
import { Sparkles, Wrench, Paintbrush, Scissors, Sofa, ArrowUpRight } from "lucide-react";

const services = [
  {
    id: "eot",
    title: "End of Tenancy Deep Clean",
    copy: "Agency-standard deep cleans that help tenants get full deposits back — and homeowners present a spotless property when it's time to sell. Ovens, carpets, grout — the lot.",
    icon: Sparkles,
    span: "md:col-span-7 md:row-span-2",
    featured: true,
  },
  {
    id: "prep",
    title: "Move-In Property Prep",
    copy: "Fresh, lettable and handover-ready — from empty shell to new-tenant standard. Also perfect for new homeowners settling into a property and wanting it spotless from day one.",
    icon: Wrench,
    span: "md:col-span-5",
  },
  {
    id: "paint",
    title: "Painting & Handyman Repairs",
    copy: "Decorating, plumbing fixes, fixture swaps, door hangs — one trusted trade.",
    icon: Paintbrush,
    span: "md:col-span-5",
  },
  {
    id: "garden",
    title: "Garden & Outdoor Tidying",
    copy: "Lawn, hedges, patios and garden waste clearance.",
    icon: Scissors,
    span: "md:col-span-6",
  },
  {
    id: "carpet",
    title: "Carpet & Upholstery Cleaning",
    copy: "Hot water extraction on carpets, sofas, mattresses — stains and odours gone.",
    icon: Sofa,
    span: "md:col-span-6",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 sm:py-32 border-t border-[#0B1215]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div>
            <div className="font-mono-label text-[#FF5A36] mb-4">· SERVICES / 01 — 05</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#0B1215] tracking-tighter max-w-2xl">
              Every job a property needs, handled by <span className="italic font-light">one person</span>.
            </h2>
          </div>
          <p className="text-[#495057] max-w-sm text-base leading-relaxed">
            No subcontractors, no sales team. You deal directly with the person doing the work —
            which is exactly why standards stay high.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4" data-testid="services-grid">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: i * 0.07 }}
                className={`${s.span} border-2 border-[#0B1215] p-8 flex flex-col justify-between min-h-[260px] ${
                  s.featured ? "bg-[#0B1215] text-[#F8F9FA]" : "bg-[#F8F9FA]"
                } group cursor-pointer hover:bg-[#FF5A36] hover:text-[#F8F9FA] transition-colors`}
                data-testid={`service-card-${s.id}`}
              >
                <div className="flex items-start justify-between">
                  <Icon size={s.featured ? 48 : 36} strokeWidth={1.5} />
                  <ArrowUpRight
                    size={24}
                    className="opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all"
                  />
                </div>
                <div>
                  <div className="font-mono-label opacity-60 mb-2">0{services.indexOf(s) + 1}</div>
                  <h3 className={`font-display tracking-tighter leading-tight ${s.featured ? "text-4xl lg:text-5xl" : "text-2xl lg:text-3xl"}`}>
                    {s.title}
                  </h3>
                  <p className={`mt-3 ${s.featured ? "text-base max-w-md" : "text-sm"} opacity-80 leading-relaxed`}>
                    {s.copy}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
